<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: [String, Number, Array],
            label: String,
            labelWidth: String,
            field: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: ''
            }
        },
        methods: {
            change_value(v) {
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
        },
        computed: {
            ...mapGetters('dictionaries/paymentDirection', {
                list: 'list'
            }),
            append() {
                return this.show_remove;
            },
            show_remove() {
                if (this.disabled) return false;
                if (!this.multiple) return false;
                if (this.value && !this.value.length) {
                    return false;
                }
                return true;
            },
        },
        watch: {},
        mounted() {
        },

        components: {},
    }
</script>
<template>
    <form-group class="dictionary dictionary-payment-direction" :label-width="labelWidth" :append="append" :label="label">
        <el-select
                :value="value"
                @change="change_value"
                @input="input_value"
                :disabled="disabled"
                :filterable="filterable"
                :multiple="multiple"
                :collapse-tags="multiple"
                :clearable="clearable">
            <el-option v-for="item in list"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <el-button
                v-if="show_remove"
                slot="append"
                icon="el-icon-close"
                title="Очистить"
                @click="change_value([])">
        </el-button>
    </form-group>
</template>
<style lang="scss">
</style>
